<template>

  <div style="display: flex; justify-content: flex-end;">
    <el-button size="default" @click="handleExport" title="导出 checklist">
      导出 checklist
    </el-button>
  </div>
  <div class="tab-content">
    <div style="margin-top: 4px">
      <el-card>
        <!-- 新增一个 table-wrapper 作为按钮定位的相对容器 -->
        <div class="table-wrapper">
          <el-table ref="tableRef" :data="tableData" :header-cell-style="tableHeaderStyle" border
                    max-height="69vh">
            <!-- 左侧固定列 -->
            <el-table-column prop="paramType" label="参数类型" fixed width="100"/>
            <el-table-column prop="keyword" label="参数项目" fixed width="150"/>

            <!-- 中间动态可扩展列 (提取值) -->
            <el-table-column v-for="file_path in filePathList" :key="file_path" :prop="file_path" min-width="160">
              <!-- Use the #header slot -->
              <template #header>
                <!-- MODIFIED: Added @click handler and cursor style for locating file -->
                <div class="truncate-header-cell" :title="file_path" @click="handleLocate(file_path, '')"
                     style="cursor: pointer;">
                  <span>{{ file_path }}</span>
                </div>
              </template>

              <template #default="{ row }">
                <el-tooltip
                    v-if="row[file_path]"
                    :content="getSourceText(row[file_path])"
                    placement="left"

                    effect="light"
                >
                    <span
                        @click="handleLocate(file_path, row.keyword)"
                        style="cursor: pointer; background: #f2f2f2;"

                        v-html="renderContent(row[file_path])"
                    >

                </span>
                </el-tooltip>

              </template>
            </el-table-column>

            <!-- 右侧固定列 -->
            <el-table-column label="状态" fixed="right" width="90">
              <template #default="{ row }">
                <!-- MODIFIED: Wrapped with el-tooltip to show error details -->
                <el-tooltip
                    :content="row.error_detail"
                    placement="top"

                    effect="light"
                >
                  <div
                      :class="['status-cell', getStatusClass(row.status)]"
                  >
                    {{ row.status }}
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="标准值" prop="standard_description" fixed="right" width="180"></el-table-column>
            <!-- 最终值确认列 -->
            <el-table-column label="最终值确认" fixed="right" width="280">
              <template #default="{ row }">
                <div v-if="!row.isEditing">
                  {{ formatRes(row.finalValue, true) }}
                </div>

                <div v-else class="edit-final-value-wrapper">
                  <div
                      v-if="row.finalValue.type === 'int' || row.finalValue.type === 'range' || row.finalValue.type === 'str'">
                    <el-input
                        v-model="row.editFinalValue.min"
                        size="small"
                        :placeholder="row.finalValue.type === 'range' ? '下限值' : '值'"
                        class="edit-input"
                    />
                  </div>
                  <div v-else-if="row.finalValue.type === 'enumeration'">
                    <el-select
                        v-model="row.editFinalValue.min"
                        size="small"
                        placeholder="请选择"
                        class="edit-select"
                    >
                      <el-option
                          v-for="item in (row.enumeration)"
                          :key="item"
                          :label="item"
                          :value="item"
                      />
                    </el-select>
                  </div>
                  <div v-else class="edit-input-placeholder">—</div>

                  <div v-if="row.finalValue.type === 'range'">
                    <el-input
                        v-model="row.editFinalValue.max"
                        size="small"
                        placeholder="上限值"
                        class="edit-input"
                    />
                  </div>
                  <div v-else class="edit-input-placeholder">—</div>


                  <div v-if="row.finalValue.type === 'int' || row.finalValue.type === 'range'">
                    <el-select
                        v-model="row.editFinalValue.unit"
                        size="small"
                        placeholder="单位"
                        class="edit-select"
                    >
                      <el-option
                          v-for="item in (row.unit_options)"
                          :key="item"
                          :label="item"
                          :value="item"
                      />
                    </el-select>
                  </div>


                  <div v-else>—</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="格式化单位" fixed="right" width="140" align="center">
              <template #default="{ row }">
                <span>{{ formatTargetRes(row) }}</span>
              </template>
            </el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" fixed="right" width="160" align="center">
              <template #default="{ row }">
                <div v-if="!row.isEditing && row.type !== 'text'" class="action-buttons">
                  <el-button size="small" type="primary" link @click="handleEdit(row)">编辑</el-button>
                  <el-divider direction="vertical"/>
                  <el-button v-if="!row.isReviewed" size="small" type="warning" link @click="handleReview(row)">
                    复核
                  </el-button>
                  <span v-else class="reviewed-text">已复核</span>
                </div>
                <div v-else-if="row.isEditing">
                  <el-button size="small" type="success" @click="handleSave(row)">保存</el-button>
                  <el-button size="small" @click="handleCancel(row)">取消</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- 左侧滚动按钮 -->
          <div v-if="showScrollButtons" class="floating-scroll-button floating-scroll-button--left">
            <el-button
                :icon="ArrowLeft"
                circle
                :disabled="!canScrollLeft"
                @click="scrollHorizontally('left')"
                title="向左滚动"
            />
          </div>

          <!-- 右侧滚动按钮 -->
          <div v-if="showScrollButtons" class="floating-scroll-button floating-scroll-button--right">
            <el-button
                :icon="ArrowRight"
                circle
                :disabled="!canScrollRight"
                @click="scrollHorizontally('right')"
                title="向右滚动"
            />
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import store from '@/store/index.js';
import {ElMessage} from 'element-plus';
import {mapState} from "vuex";
// 导入需要的图标
import {ArrowLeft, ArrowRight, Download} from '@element-plus/icons-vue';
import {locationByPathKeyword, setThirdRes} from "@/components/file_process_js/utils";

export default {
  name: 'ComparisonTable',
  components: {
    Download,
    ArrowLeft,
    ArrowRight
  },
  data() {
    return {
      tableData: [],
      tableHeaderStyle: {
        color: 'black',
        fontWeight: 'bold',
        background: '#f5f7fa',
      },
      tableKey: 0,
      fileInfoMap: {},
      filePathList: [],

      // 用于悬浮滚动按钮的状态
      showScrollButtons: false,
      canScrollLeft: false,
      canScrollRight: false,
      scrollableTableBody: null, // 存储可滚动的DOM元素
    };
  },

  // 将图标暴露给模板使用
  setup() {
    return {
      ArrowLeft,
      ArrowRight
    }
  },

  computed: {
    ...mapState(['commonFileChangeSign', 'checkListChangeSign']),
  },

  watch: {
    checkListChangeSign(currentSign) {
      if (currentSign > 0) {
        this.recalculateTableData();
      }
    },
    // 监听表格数据变化，数据更新后重新检查滚动状态
    tableData() {
      this.$nextTick(() => {
        this.initializeScrollWatcher();
      });
    },
  },

  // 在组件挂载后初始化滚动监听
  mounted() {
    this.$nextTick(() => {
      this.initializeScrollWatcher();
    });
    // 监听窗口大小变化，因为这可能导致滚动条出现或消失
    window.addEventListener('resize', this.updateScrollButtonState);
  },

  // 在组件销毁前清除监听器，防止内存泄漏
  beforeUnmount() {
    if (this.scrollableTableBody) {
      this.scrollableTableBody.removeEventListener('scroll', this.updateScrollButtonState);
    }
    window.removeEventListener('resize', this.updateScrollButtonState);
  },

  methods: {
    // 初始化滚动监听器
    initializeScrollWatcher() {
      // 通过 $refs 获取 el-table 的 DOM 元素，并找到内部真正的滚动容器
      // el-table 的滚动容器通常是 class 为 .el-scrollbar__wrap 的 div
      const tableInstance = this.$refs.tableRef;
      if (tableInstance && tableInstance.$el) {
        const scrollWrapper = tableInstance.$el.querySelector('.el-scrollbar__wrap');
        if (scrollWrapper) {
          // 如果之前已经绑定了监听器，先移除旧的
          if (this.scrollableTableBody) {
            this.scrollableTableBody.removeEventListener('scroll', this.updateScrollButtonState);
          }

          this.scrollableTableBody = scrollWrapper;
          // 添加滚动事件监听
          this.scrollableTableBody.addEventListener('scroll', this.updateScrollButtonState);
          // 立即更新一次按钮状态
          this.updateScrollButtonState();
        }
      }
    },

    // 更新滚动按钮的可见性和禁用状态
    updateScrollButtonState() {
      if (!this.scrollableTableBody) return;

      const {scrollLeft, scrollWidth, clientWidth} = this.scrollableTableBody;

      // 判断是否需要显示滚动条（即内容宽度大于容器宽度）
      this.showScrollButtons = scrollWidth > clientWidth;

      // 判断是否可以向左滚动 (加上一个小的容差值（如1），避免浮点数精度问题)
      this.canScrollLeft = scrollLeft > 1;

      // 判断是否可以向右滚动
      this.canScrollRight = scrollLeft < (scrollWidth - clientWidth - 1);
    },

    // 处理按钮点击，执行滚动
    scrollHorizontally(direction) {
      if (!this.scrollableTableBody) return;

      // 定义每次滚动的距离，可以根据需要调整
      const scrollAmount = 300;

      if (direction === 'left') {
        // 使用 smooth 行为实现平滑滚动
        this.scrollableTableBody.scrollBy({left: -scrollAmount, behavior: 'smooth'});
      } else if (direction === 'right') {
        this.scrollableTableBody.scrollBy({left: scrollAmount, behavior: 'smooth'});
      }
    },

    formatHeaderLabel(path, maxLength = 35) {
      if (path.length <= maxLength) {
        return path;
      }
      return '...' + path.slice(-maxLength + 3);
    },

    getThirdData() {
      const tlDataList = this.tableData.map((item) => {
        return {...item.finalValue}
      })
      const tlDataMap = {}
      tlDataList.forEach((item) => {
        tlDataMap[item.keyword] = item;
      })

      const thirdConfig = store.state.thirdConfig;
      const thirdDataMap = {}
      thirdConfig.map((item) => {
        thirdDataMap[item['keySZID']] = item
      })

      console.log("getThirdData start", JSON.stringify(tlDataMap))

      const res = []
      thirdConfig.forEach((item) => {
        const thirdId = item['keySZID']
        // if (thirdId === "BoardThickness") {
        //   console.log("BoardThickness start", item, JSON.stringify(tlDataMap["成品板厚"]))
        //   console.log("BoardThickness start thirdDataMap ", thirdDataMap[thirdId])
        // }
        const itemValueRes = setThirdRes(thirdId, thirdDataMap, tlDataMap)
        item['value'] = itemValueRes
        res.push([item['keyword'], item['keySZID'], item['value'], item['target_unit']]);
      })

      console.log("tlDataList", tlDataList, thirdDataMap, res)
      return res
    },

    async handleExport() {
      // 1. 基础校验
      if (this.tableData.length === 0) {
        ElMessage.warning('没有可导出的数据！');
        return;
      }

      // 2. 创建工作簿对象
      const wb = XLSX.utils.book_new();

      // ================= SHEET 1: 对比数据 (主数据，建议放第一位) =================
      const headers = ['参数类型', '参数项目'];
      this.filePathList.forEach(path => {
        headers.push(`${path} (提取值)`);
      });
      headers.push('状态', '最终值确认');

      const mainData = this.tableData.map(row => {
        const dataRow = [row.paramType, row.keyword];
        this.filePathList.forEach(path => {
          dataRow.push(this.formatRes(row[path]));
        });
        dataRow.push(
            row.status,
            this.formatRes(row.finalValue, true)
        );
        return dataRow;
      });

      // 组合表头和数据
      const mainExcelData = [headers, ...mainData];
      const wsMain = XLSX.utils.aoa_to_sheet(mainExcelData);

      // 将主数据作为第一个 Sheet 添加
      XLSX.utils.book_append_sheet(wb, wsMain, '对比数据');


      // ================= SHEET 2: 字段映射数据 (附表) =================
      try {
        const thirdHeaders = ["项目名称", '字段名称', '值', '单位'];
        // 增加空值保护，防止 undefined 报错
        const thirdList = this.getThirdData() || [];

        // 确保 thirdList 是二维数组 (例如: [['id', 1], ['name', 'test']])
        // 如果 getThirdData 返回的是对象数组 [{key:'id', val:1}]，需要先转换，否则 aoa_to_sheet 会出错
        const thirdExcelData = [thirdHeaders, ...thirdList];

        const wsThird = XLSX.utils.aoa_to_sheet(thirdExcelData);

        // 将附表作为第二个 Sheet 添加
        XLSX.utils.book_append_sheet(wb, wsThird, '字段映射数据');
      } catch (e) {
        console.error('第二个Sheet生成失败', e);
      }

      // 3. 生成二进制数据 (而不是直接 writeFile)
      // bookType: 'xlsx', type: 'array' 是必须的，以便传输给 Electron
      const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});

      // 4. 获取上次导出的路径记录
      const lastExportPath = localStorage.getItem('LAST_EXPORT_PATH');

      // 5. 调用 Electron 保存
      const result = await window.electronAPI.saveExcelFile({
        buffer: wbout,
        defaultName: '参数对比表.xlsx',
        lastPath: lastExportPath // 传入专属的导出路径
      });

      // 6. 处理结果
      if (result.success) {
        // 保存成功后，更新“导出路径”记录
        if (result.savedDir) {
          localStorage.setItem('LAST_EXPORT_PATH', result.savedDir);
        }
        // !! 只有在这里才提示成功 !!
        ElMessage.success('导出成功！文件已保存。');
      } else if (result.status === 'canceled') {
        ElMessage.info('用户取消导出');
      } else {
        ElMessage.error('导出失败：' + result.error);
      }
    },

    recalculateTableData() {
      const allFiles = store.state.commonObjList;
      const parsedFileList = allFiles.filter(fileInfo => fileInfo.status_code >= 0);
      const fileInfoMap = {};
      parsedFileList.forEach(fileInfo => {
        fileInfoMap[fileInfo.file_path] = fileInfo;
      });
      this.fileInfoMap = fileInfoMap
      this.filePathList = Object.keys(fileInfoMap)

      const kvParameterConfig = store.state.mainConfig.kvParams;
      const textParameterConfig = store.state.mainConfig.textParams;
      const checkKeys = store.state.mainConfig.checklistKeys

      const newKVTableData = this.getTableByConfig(kvParameterConfig, checkKeys)
      const newTextTableData = this.getTableByConfig(textParameterConfig, checkKeys)
      console.log("new checklist Data");
      const newTableData = newKVTableData.concat(newTextTableData);

      this.tableData = newTableData;
      this.tableKey += 1
      this.$nextTick(() => {
        if (this.$refs.tableRef) {
          this.$refs.tableRef.doLayout();
        }
      });
    },

    getTableByConfig(parameterConfig, checkKeys) {
      const currentFilePathList = this.filePathList;
      const checklistMap = store.state.mainConfig.checklistMap;

      const paramMap = {}
      const selected = {}
      parameterConfig.forEach(item => {
        paramMap[item['keyword']] = item
        selected[item['keyword']] = false
      })

      const resTable = []

      checkKeys.forEach(paramKey => {
        const param = paramMap[paramKey];
        if (!param) {
          // 如果没有对应参数，说明展示位置中无对应keyword，符合预期，跳过即可； 全局校验key不存在在初始阶段就已经校验过了
          return
        }
        const finalValueObj = checklistMap[param.keyword] || {}
        finalValueObj["target_unit_value"] = null;
        finalValueObj["target_unit_min"] = null;
        finalValueObj["target_unit_max"] = null;
        finalValueObj["target_unit"] = this.getTransformUnit(param.keyword)
        const row = {
          paramType: param.category,
          keyword: param.keyword,
          type: param.type,
          unit_options: param.unit_options,
          enumeration: param.enumeration,
          isEditing: false,
          isReviewed: false,
          finalValue: finalValueObj,
          editFinalValue: {min: null, max: null, unit: null},
          standard_description: this.getStandardText(param.keyword),
          status: "",
        };
        currentFilePathList.forEach(file_path => {
          row[file_path] = this.getFileKeywordRes(file_path, param.keyword)
        });

        this.refreshFinalValue(row, currentFilePathList);
        resTable.push(row);
        selected[param.keyword] = true;
      });

      // 对于不在checkKeys 中的需要再次检查是否文本类型，如果是文本类型，需要添加到末尾
      for (let paramKey in selected) {
        const param = checklistMap[paramKey];
        if (!selected[paramKey] && param.type === "text") {

          const row = {
            paramType: param.category,
            keyword: param.keyword,
            type: param.type,
            unit_options: param.unit_options,
            enumeration: param.enumeration,
            isEditing: false,
            isReviewed: false,
            finalValue: checklistMap[param.keyword] || {},
            editFinalValue: {min: null, max: null, unit: null},
            standard_description: "",
            status: '警惕',
          };

          currentFilePathList.forEach(file_path => {
            row[file_path] = this.getFileKeywordRes(file_path, param.keyword)
          });
          resTable.push(row);
        }
      }

      return resTable
    },

    getFileKeywordRes(filePath, keyword) {
      const targetFileInfo = this.fileInfoMap[filePath]
      const paramsMap = targetFileInfo.paramsMap
      const targetParamInFile = paramsMap[keyword]

      if (!targetParamInFile || !targetParamInFile.res.length > 0) {
        return null
      }

      let copyRes;
      const targetRes = targetParamInFile.res;
      switch (targetParamInFile.type) {
        case 'int':
        case 'range':
        case 'str':
        case 'enumeration':
          copyRes = {...targetRes[0]};
          return copyRes;
        case 'text':
          copyRes = {...targetRes[0]};
          let showText = "";
          for (let i = 0; i < targetRes.length; i++) {
            showText += `${i}: ${targetRes[i].value}\n`;
          }
          copyRes['showText'] = showText;
          return copyRes;
      }
    },

    refreshFinalValue(row, filePathList) {
      // 1. 初始化，增加 error_detail 属性
      row.error_detail = null;
      const valueGroups1 = {}; // 用于存储 { value: [filePath1, filePath2] }
      const valueGroups2 = {}; // 用于 range 类型的上限值
      let orgFileObj; // 记录一个有效文件的值，用于后续回填
      let status = "正常";
      let detail = ""
      // 2. 遍历文件，收集值并按值对文件路径进行分组
      filePathList.forEach(filePath => {
        const targetParamValue = row[filePath];
        if (!targetParamValue) return;

        orgFileObj = targetParamValue; // 暂存一个对象，以便在“正常”状态下使用

        let key1, key2;

        switch (row.type) {
          case 'int': {
            const numValue = this.parseNumeric(targetParamValue.value);
            if (numValue === undefined) { // 使用 undefined 判断解析失败
              status = "异常";
              detail = `文件 '${filePath}' 中的值 '${targetParamValue.value}' 解析为数值时异常。`;
              return; // 提前退出 forEach
            }
            const unitScale = this.getUnitScale(targetParamValue.unit);
            key1 = numValue * unitScale;
            break;
          }
          case 'range': {
            const minNum = this.parseNumeric(targetParamValue.min);
            const maxNum = this.parseNumeric(targetParamValue.max);
            if (minNum === undefined && maxNum === undefined) {
              status = "异常";
              detail = `文件 '${filePath}' 中的区间值 '${targetParamValue.min}~${targetParamValue.max}' 解析异常。`;
              return
            }

            // 用户可能只提及单边，不能视为异常
            // if ((targetParamValue.min && minNum === undefined) || (targetParamValue.max && maxNum === undefined)) {
            //   status = "异常";
            //   row.error_detail = `文件 '${filePath}' 中的区间值 '${targetParamValue.min}~${targetParamValue.max}' 解析异常。`;
            //   return;
            // }

            const unitScale = this.getUnitScale(targetParamValue.unit);
            key1 = minNum * unitScale;
            key2 = maxNum * unitScale;
            break;
          }
          case 'str':
          case 'enumeration':
            if (typeof targetParamValue.value === "string" && !targetParamValue.value.trim()) {
              status = "异常";
              detail = `文件 '${filePath}' 文本值提取为空，解析异常，请进一步查看原文信息`;
              return
            }
            key1 = targetParamValue.value;
            break;
        }

        // 将文件路径添加到对应值的数组中
        if (key1 !== undefined && key1 !== null) {
          const groupKey1 = String(key1).replaceAll(" ", ""); // 统一 key 格式
          if (!valueGroups1[groupKey1]) valueGroups1[groupKey1] = [];
          valueGroups1[groupKey1].push(filePath);
        }
        if (key2 !== undefined && key2 !== null) {
          const groupKey2 = String(key2).replaceAll(" ", "");
          if (!valueGroups2[groupKey2]) valueGroups2[groupKey2] = [];
          valueGroups2[groupKey2].push(filePath);
        }
      });

      if (status === "异常") {
        row.status = "异常";
        row.finalValue.status = "异常";
        // 清空最终值
        row.finalValue.min = "";
        row.finalValue.max = "";
        row.finalValue.unit = "";
        row.finalValue.value = "";
        row.error_detail = detail
        return; // 如果已发现异常，直接结束
      }

      // 3. 分析分组结果，判断状态
      const uniqueValues1 = Object.keys(valueGroups1);
      const uniqueValues2 = Object.keys(valueGroups2);

      switch (row.type) {
        case 'int':
        case 'str':
        case 'enumeration':
          if (uniqueValues1.length === 0) {
            status = "缺失";
          } else if (uniqueValues1.length > 1) {
            status = "冲突";
            const conflictDetails = uniqueValues1.map(value =>
                `值 '${value}': [${valueGroups1[value].map(p => this.formatHeaderLabel(p, 20)).join(', ')}]`
            );
            detail = `发现不一致的值: ${conflictDetails.join('; ')}`;
          }
          break;
        case 'range':
          if (uniqueValues1.length === 0 && uniqueValues2.length === 0) {
            status = "缺失";
          } else if (uniqueValues1.length > 1 || uniqueValues2.length > 1) {
            status = "冲突";
            let details = [];
            if (uniqueValues1.length > 1) {
              const minDetails = uniqueValues1.map(val => `下限 '${val}': [${valueGroups1[val].map(p => this.formatHeaderLabel(p, 20)).join(', ')}]`);
              details.push(`下限值不一致: ${minDetails.join('; ')}`);
            }
            if (uniqueValues2.length > 1) {
              const maxDetails = uniqueValues2.map(val => `上限 '${val}': [${valueGroups2[val].map(p => this.formatHeaderLabel(p, 20)).join(', ')}]`);
              details.push(`上限值不一致: ${maxDetails.join('; ')}`);
            }
            detail = details.join(' | ');
          }
          break;
      }


      // 4. 结合标准值进一步修改状态
      const standardConfigMap = store.state.mainConfig.checklistStandardMap;
      const targetStandardConfig = standardConfigMap[row.keyword];

      if (status === "正常") {
        const [checkStatus, err_detail] = this.checkValueValid(orgFileObj, row.type, row.enumeration, row.unit_options);
        status = checkStatus
        detail = err_detail
      } else if (status === "缺失") {
        if (targetStandardConfig.require !== "yes") {
          status = "默认";
        }
      }

      row.status = status;
      row.finalValue.status = status;
      row.error_detail = detail

      // 5. 根据最终状态决定是否填充 finalValue
      if (row.status === "正常") {
        row.finalValue.min = orgFileObj.min;
        row.finalValue.max = orgFileObj.max;
        row.finalValue.unit = orgFileObj.unit;
        row.finalValue.value = orgFileObj.value;
        this.updateTargetUnitValues(row)
      } else {
        row.finalValue.min = "";
        row.finalValue.max = "";
        row.finalValue.unit = "";
        row.finalValue.value = "";
      }

      if (status === "异常" || status === "冲突") {
        // console.log("refreshFinalValue invalid status", row, status, row.error_detail);
      }
    },

    // 还需要调整一下 parseNumeric，让它在失败时返回一个明确的标志，比如 undefined
    parseNumeric(input) {
      if (typeof input === 'number' && isFinite(input)) {
        return input;
      }
      if (typeof input !== 'string') {
        return undefined; // 改为返回 undefined
      }
      let trimmedInput = input.trim();
      if (trimmedInput === '') {
        return undefined; // 改为返回 undefined
      }
      const num = Number(trimmedInput);
      if (isFinite(num)) {
        return num;
      } else {
        return undefined; // 改为返回 undefined
      }
    },

    getSourceText(valueObj) {
      if (!valueObj) {
        return ""
      }
      return valueObj['sourceText'];
    },

    renderContent(text) {
      const value = this.formatRes(text, true);

      // 如果为空或只有空格
      if (value === '  ') {
        console.log("value.length", value, value.length)
        // 返回一个非中断空格，它会占据空间
        return '&nbsp;&nbsp;&nbsp;&nbsp;';
      }

      // 对于普通字符串，直接返回（v-html 会处理特殊字符，如果需要请进行转义）
      return value;
    },

    formatRes(valueObj, forceShow = false) {
      if (!valueObj) return "";
      if (valueObj.status === "异常" && !forceShow) {
        return "  "
      }
      // console.log("formatRes", valueObj)
      switch (valueObj.type) {
        case 'int':
        case 'enumeration':
        case 'str':
          return valueObj.value ? `${valueObj.value ?? ''} ${valueObj.unit ?? ''}`.trim() : "  ";
        case 'range':
          return (valueObj.min || valueObj.max) ? `${valueObj.min ?? ''} ~ ${valueObj.max ?? ''} ${valueObj.unit ?? ''}`.trim() : "  ";
        case 'text':
          return valueObj.showText ?? "  ";
        default:
          return "";
      }
    },

    handleReview(row) {
      row.isReviewed = true;
      ElMessage.success('复核成功');
    },

    handleEdit(row) {
      row.isEditing = true;
      const final = row.finalValue;
      if (final.type === 'int' || final.type === 'str' || final.type === 'enumeration') {
        row.editFinalValue = {min: final.value, max: null, unit: final.unit};
      } else if (final.type === 'range') {
        row.editFinalValue = {min: final.min, max: final.max, unit: final.unit};
      }
    },

    handleSave(row) {
      const final = row.finalValue;
      const editVal = row.editFinalValue;
      if (final.type === 'int' || final.type === 'str' || final.type === 'enumeration') {
        final.value = editVal.min;
        final.unit = editVal.unit;
      } else if (final.type === 'range') {
        final.min = editVal.min;
        final.max = editVal.max;
        final.unit = editVal.unit;
      }

      const [checkStatus, err_detail] = this.checkValueValid(final, row.type, row.enumeration, row.unit_options, true)
      if (checkStatus === "正常") {
        ElMessage.success('保存成功！');
      }

      row.status = checkStatus
      final.status = checkStatus
      row.isEditing = false;
      row.isReviewed = false;

      this.updateTargetUnitValues(row);
    },

    getTransformUnit(keyword) {
      const checklistStandardMap = store.state.mainConfig.checklistStandardMap
      const targetConfig = checklistStandardMap[keyword];
      if (!targetConfig) {
        console.log("getTransformUnit fail keyword", keyword)
        return ""
      }
      return targetConfig.target_unit
    },

    getStandardText(keyword) {
      const checklistStandardMap = store.state.mainConfig.checklistStandardMap
      const targetConfig = checklistStandardMap[keyword];
      let valueStr = ""
      if (targetConfig.standard_value) {
        valueStr = `${targetConfig.standard_value} ${targetConfig.unit}`;
      } else if (targetConfig.max_value || targetConfig.min_value) {
        valueStr = `${targetConfig.min_value} ~ ${targetConfig.max_value} ${targetConfig.unit}`;
      }
      return `${valueStr} (${targetConfig.require === "yes" ? "必填项" : "非必填项"})`;
    },

    // 计算并更新转换后的目标单位值
    updateTargetUnitValues(row) {
      // 初始化清空
      row.finalValue.target_unit_value = null;
      row.finalValue.target_unit_min = null;
      row.finalValue.target_unit_max = null;

      const finalVal = row.finalValue;
      const targetUnit = row.finalValue.target_unit;
      const sourceUnit = finalVal.unit;

      // 如果没有目标单位，或者没有源单位，或者当前状态异常/缺失，则不计算
      if (!targetUnit || !sourceUnit || finalVal.status === '异常' || finalVal.status === '缺失') {
        return;
      }

      // 获取换算比例 (标准单位 = 值 * scale)
      const sourceScale = this.getUnitScale(sourceUnit);
      const targetScale = this.getUnitScale(targetUnit);

      // 计算转换系数：源值 * (源比例 / 目标比例) = 目标值
      // 例如：1km 转 m。 Scale(km)=1000, Scale(m)=1.  1 * (1000/1) = 1000
      const ratio = sourceScale / targetScale;

      // 辅助函数：处理浮点数精度，保留4位小数并去尾
      const calc = (val) => {
        const num = this.parseNumeric(val);
        if (num === undefined) return null;
        const res = num * ratio;
        return parseFloat(res.toFixed(4)); // 避免 0.30000000004 这种情况
      };

      if (row.type === 'int') {
        row.finalValue.target_unit_value = calc(finalVal.value);
      } else if (row.type === 'range') {
        row.finalValue.target_unit_min = calc(finalVal.min);
        row.finalValue.target_unit_max = calc(finalVal.max);
      }
    },

    // 格式化目标单位值的显示
    formatTargetRes(row) {
      if (!row.finalValue.target_unit) {
        // console.log("formatTargetRes fail", row);
        return "-";
      }

      // 如果原始值状态不正常，不显示转换值
      if (row.finalValue.status === '异常' || row.finalValue.status === '缺失') {
        return "";
      }

      if (row.finalValue.type === 'int') {
        if (row.finalValue.target_unit_value !== null && row.finalValue.target_unit_value !== undefined) {
          return `${row.finalValue.target_unit_value} ${row.finalValue.target_unit}`;
        }
      } else if (row.type === 'range') {
        const min = row.finalValue.target_unit_min;
        const max = row.finalValue.target_unit_max;
        if (min !== null || max !== null) {
          return `${min ?? ''} ~ ${max ?? ''} ${row.finalValue.target_unit}`;
        }
      }

      return "";
    },

    // 新增方法：根据状态返回对应的 CSS 类名
    getStatusClass(status) {
      switch (status) {
        case '异常':
        case '冲突':
        case '超限': // 将“超限”也归为红色警惕
          return 'status-red';
        case '缺失':
        case '警惕':
          return 'status-yellow';
        case '默认':
          return 'status-grey';
        case '正常':
          return 'status-green';
        default:
          return ''; // 默认情况不添加特定颜色
      }
    },

    checkValueValid(finalValue, type, enumeration, unit_options, showWarning) {
      const checklistStandardMap = store.state.mainConfig.checklistStandardMap
      const standardConfig = checklistStandardMap[finalValue.keyword];

      const standard_value = standardConfig.standard_value
      const standard_min = standardConfig.min_value
      const standard_max = standardConfig.max_value
      const standard_unit = standardConfig.unit

      const input_value = finalValue.value
      const input_min = finalValue.min
      const input_max = finalValue.max
      const input_unit = finalValue.unit

      const unitScale = this.getUnitScale(input_unit);
      const standardScale = this.getUnitScale(standard_unit);

      let outer = standardConfig.outer
      let single = standardConfig.single
      let full_match = standardConfig.full_match
      let err_detail = ""

      // 利用undefined 与 nan 的比大小的特性（为false），同时standard_value 未提及 则看standard_min与standard_max， 都未提及则为true

      switch (type) {
        case 'int':
          if (input_unit && !unit_options.includes(input_unit)) { // 增加对input_unit非空的判断
            if (showWarning) {
              ElMessage.warning('非法单位');
            }
            err_detail = `异常状态，当前参数期望单位：[${unit_options}]，实际提取单位：[${input_unit}]`
            return ["异常", err_detail]
          }

          const checkNumberValue = this.parseNumeric(input_value);
          if (!checkNumberValue) {
            if (showWarning) {
              ElMessage.warning('非数值输入');
            }
            err_detail = `异常状态，当前参数期望数值类型`
            return ["异常", err_detail]
          }

          const intFinalValue = checkNumberValue * unitScale;
          const intStandardValue = standard_value * standardScale;
          if (standard_value) {
            const res = intFinalValue === intStandardValue;
            if (!res) {
              if (showWarning) {
                ElMessage.warning('非限定标准值');
              }
              err_detail = `超限状态，该参数期望数值${standard_value}, 期望单位${standard_unit},换算标准值${intStandardValue};
               而实际数值${input_value}, 实际单位${input_unit}，实际换算值为${intStandardValue}`
              return ["超限", err_detail]
            }

          } else if (standard_min || standard_max) {

            const standardNumberMin = standard_min * standardScale;
            const standardNumberMax = standard_max * standardScale;
            const res = (standard_min ? intFinalValue >= standardNumberMin : true) && (standard_max ? intFinalValue <= standardNumberMax : true)
            const varStr = standard_min ? `${standard_min}${standard_unit}以上` : `${standard_max}${standard_unit}以下`
            if (!res) {
              if (showWarning) {
                ElMessage.warning('输入值超限，请检查数值及单位换算');
              }

              err_detail = `异常状态，该参数期望${varStr};
               而实际数值${input_value}, 实际单位为：${input_unit}`
              return ["超限", err_detail]
            }

          }
          break

        case 'range':
          if (!unit_options.includes(input_unit)) {
            if (showWarning) {
              ElMessage.warning('非法单位');
            }
            err_detail = `异常状态，当前参数期望单位：[${unit_options}]，实际提取单位：[${input_unit}]`
            return ["异常", err_detail]
          }

          const checkNumberMin = this.parseNumeric(input_min);
          const checkNumberMax = this.parseNumeric(input_max);

          const intFinalMin = checkNumberMin * unitScale;
          const intFinalMax = checkNumberMax * unitScale;

          const standardNumberMin = standard_min * standardScale;
          const standardNumberMax = standard_max * standardScale;

          // console.log("standardNumberMin, standardNumberMax, intFinalMin, intFinalMax, unitScale, standardScale",
          //     standardNumberMin, standardNumberMax, intFinalMin, intFinalMax, unitScale, standardScale, input_unit, standard_unit)

          if (!checkNumberMin && !checkNumberMax) {
            if (showWarning) {
              ElMessage.warning('区间数值 上限和下限不可同时为空');
            }
            // todo 添加文件路径
            err_detail = `缺失状态，当前提取出的参数，上限区间和下限区间均未提取到`
            return ["缺失", err_detail]
          }

          if (standard_min || standard_max) {
            let maxOk;
            let minOk;

            if (outer) {
              maxOk = standard_max ? intFinalMax >= standardNumberMax : true
              minOk = standard_min ? intFinalMin <= standardNumberMin : true
            } else {
              maxOk = standard_max ? intFinalMax <= standardNumberMax : true
              minOk = standard_min ? intFinalMin >= standardNumberMin : true
            }
            // single 单边模式是全匹配模型下的一个分支，用于只提取到一边的情况下，仅看单边是否完全符合
            // 单边模式只要求单边全匹配， 否则双边都要全匹配
            if (full_match) {
              const singleCondition = (intFinalMax && !intFinalMin) || (!intFinalMax && intFinalMin)
              let match = true
              if (single && singleCondition) {
                if (!maxOk && !minOk) {
                  match = false
                }
              } else {
                if (!maxOk || !minOk) {
                  match = false
                }
              }

              if (!match) {
                err_detail = `超限状态，当前参数期望客户显式提及的要求区间完全在期望范围内;
                期望区间：[${standard_min}~${standard_max}${standard_unit}] ;
                客户显式提及${input_min}/${input_max}${input_unit} 存在非期望区间`

                if (outer) err_detail = `${err_detail} (注意该项取外区间为有效值，而非内区间)`;
                return ["超限", err_detail]
              }

            } else {
              const partialMatch = (intFinalMax >= standardNumberMin) && (intFinalMin >= standardNumberMax);
              if (!partialMatch) {
                err_detail = `超限状态，当前参数期望区间与客户区间有部分重合;
                期望区间：[${standard_min}~${standard_max}${standard_unit}] ;
                实际提取：[${input_min} ${input_max}${input_unit}]`

                if (outer) err_detail = `${err_detail} (注意该项取外区间为有效值，而非内区间)`;
                return ["超限", err_detail]
              }
            }
          }
          break

        case 'str':
          const strCheck = standard_value ? standard_value === input_value : true
          if (!strCheck) {
            if (showWarning) {
              ElMessage.warning('输入不符合标准值');
            }
            err_detail = `异常状态，该参数期望文本${standard_value};
               而实际文本${input_value}`
            return ["超限", err_detail]
          }

          break
        case 'enumeration':
          const enumerationCheck = enumeration.includes(input_value)
          if (!enumerationCheck) {
            if (showWarning) {
              ElMessage.warning('值不符合设定');
            }
            err_detail = `异常状态，当前参数期望文本范围：[${enumeration}]，实际提取单位不在范围内：${input_value}`
            return ["异常", err_detail]
          }

          break
        case 'text':
          break
      }

      return ["正常", ""]
    },

    handleCancel(row) {
      row.isEditing = false;
    },

    async handleLocate(file_path, keyword) {
      console.log(`准备前往定位:`, file_path, keyword);
      await locationByPathKeyword(file_path, keyword)
    },

    getUnitScale(unit) {
      const unitScaleConfigs = store.state.mainConfig.units;
      let ratio = 1;
      unitScaleConfigs.forEach(unitConfig => {
        if (unitConfig.name === unit) {
          ratio = unitConfig.ratio;
        }
      })

      return ratio
    }
  }
}
</script>

<style scoped>
.table-wrapper {
  position: relative;
}

.floating-scroll-button {
  position: absolute;
  top: 50%; /* 垂直居中 */
  transform: translateY(-50%);
  z-index: 10;
  opacity: 0.7; /* 让按钮半透明，减少对下方内容的遮挡 */
  transition: opacity 0.3s;
}

.floating-scroll-button:hover {
  opacity: 1; /* 鼠标悬浮时不透明 */
}

.floating-scroll-button--left {
  /*
    左侧固定列总宽度为: 100px (参数类型) + 150px (参数项目) = 250px
    我们将按钮放在 250px 再往右一点的位置。
  */
  left: 255px;
}

.floating-scroll-button--right {
  /*
    右侧固定列总宽度为: 90px (状态) + 300px (最终值确认) + 160px (操作) = 550px
    我们将按钮放在 550px 再往左一点的位置。
    加上滚动条的宽度（约17px），给一点额外的间距。
  */
  right: 575px;
}

/* 原始状态单元格基础样式 */
.status-cell {
  padding: 3px;
  border-radius: 4px;
  text-align: center;
  color: #333; /* 默认文本颜色 */
}

/* 优化后的状态样式 */
.status-red {
  background-color: #fcebeb; /* 浅红背景 */
  color: #f56c6c; /* 红文本 */
}

.status-yellow {
  background-color: #fdf6ec; /* 浅黄背景 */
  color: #e6a23c; /* 黄文本 */
}

.status-grey {
  background-color: #f4f4f5; /* 浅灰背景 */
  color: #909399; /* 灰文本 */
}

.status-green {
  background-color: #e1f3d8; /* 浅绿背景 */
  color: #67c23a; /* 绿文本 */
}

.edit-final-value-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-input {
  flex: 1;
}

.edit-input-placeholder {
  flex: 1;
  text-align: center;
  color: #999;
}

.edit-select {
  width: 100px;
}

.truncate-header-cell {
  direction: rtl;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 160px;
}

.truncate-header-cell span {
  direction: ltr;
  display: inline-block;
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px; /* 添加间距 */
}

.reviewed-text {
  color: #67c23a;
  font-size: 12px;
  user-select: none;
}
</style>